import Skeleton from "react-loading-skeleton";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";

import "react-loading-skeleton/dist/skeleton.css";

export function NoteListSkeletons() {
  return (
    <ul className="tw:flex tw:flex-col tw:gap-5">
      {Array.from({ length: 5 }).map((_, i) => (
        <NoteItemSkeleton key={i} />
      ))}
    </ul>
  );
}

function NoteItemSkeleton() {
  return (
    <li>
      <DashboardCard2
        className="tw:p-0!"
        classNameChildren="tw:grid tw:gap-4 tw:lg:grid-cols-[2fr_0.6fr_0.75fr_min-content] tw:lg:items-center tw:h-24 tw:px-8 tw:py-2"
      >
        {/* Icon + title */}
        <div className="tw:flex tw:items-center tw:gap-x-4">
          <Skeleton circle containerClassName="tw:flex tw:shrink-0" height={36} width={36} />
          <div>
            <Skeleton height={16} width={360} />
            <Skeleton className="tw:mt-1" height={13} width={120} />
          </div>
        </div>

        {/* Badge */}
        <Skeleton borderRadius={4} height={16} width={90} />

        {/* Metadata */}
        <div className="tw:flex tw:flex-col">
          <Skeleton height={12} width={80} />
          <Skeleton height={12} width={70} />
          <Skeleton height={12} width={60} />
        </div>

        {/* View Full Note link */}
        <Skeleton height={16} width={90} />
      </DashboardCard2>
    </li>
  );
}
